import * as signalR from "@microsoft/signalr";
import { logError, logInfo } from "@common/Logger";

const delays = [
    1000, 2000,
    3000, 3000, 3000, 3000, 3000, 3000, 3000, 3000, 3000, 3000,
    5000, 5000, 5000, 5000, 5000, 5000, 5000, 5000, 5000, 5000,
    10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000,
    15000, 15000, 15000, 15000, 15000, 15000, 15000, 15000,
    30000, 30000, 30000, 30000, 30000, 30000, 30000, 30000];

const conn = new signalR.HubConnectionBuilder()
    .withUrl("/workflows")
    .withAutomaticReconnect(delays)
    //.configureLogging(signalR.LogLevel.Trace)
    .build();

conn.serverTimeoutInMilliseconds = 100000;

export const connection = conn;

conn.onclose(err => logError(err));
conn.onreconnecting(connectionId => logInfo(`Reconnecting ${connectionId}`));
conn.onreconnected(connectionId => logInfo(`Reconnected ${connectionId}`));

export function connect(callback: (conn: signalR.HubConnection) => void): void {
    conn.start()
        .then(() => {
            logInfo("Connected");
            callback(conn);
        })
        .catch(err => logError(err));
}